(function(){
  // Product gallery thumbnails
  document.addEventListener('click', function(e){
    var thumb = e.target.closest('.thumb');
    if(thumb){
      var main = document.querySelector('.gallery-main img');
      if(main && thumb.dataset.img){ main.src = thumb.dataset.img; }
      document.querySelectorAll('.thumb').forEach(function(t){t.classList.remove('is-active')});
      thumb.classList.add('is-active');
    }
    // FAQ accordion (one open at a time)
    var q = e.target.closest('.faq-q');
    if(q){
      var item = q.parentElement;
      var wasOpen = item.classList.contains('open');
      item.closest('.faq').querySelectorAll('.faq-item').forEach(function(i){
        i.classList.remove('open');
        var a = i.querySelector('.faq-a'); if(a) a.style.maxHeight = null;
      });
      if(!wasOpen){
        item.classList.add('open');
        var a = item.querySelector('.faq-a'); if(a) a.style.maxHeight = a.scrollHeight + 'px';
      }
    }
    // Tier selection -> update quantity input if present
    var tier = e.target.closest('.tier');
    if(tier && tier.dataset.qty){
      document.querySelectorAll('.tier').forEach(function(t){t.classList.remove('popular')});
      tier.classList.add('popular');
      var qtyInput = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      if(qtyInput){ qtyInput.value = tier.dataset.qty; }
    }
  });

  // Sticky mobile CTA once hero scrolls out
  var hero = document.querySelector('.product-hero');
  var sticky = document.querySelector('.sticky-cta');
  if(hero && sticky){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ sticky.classList.remove('show'); }
        else { sticky.classList.add('show'); }
      });
    }, {threshold:0});
    io.observe(hero);
  }

  // Slideshow
  var shows = document.querySelectorAll('.slideshow');
  shows.forEach(function(show){
    var slides = show.querySelectorAll('.slide');
    if(slides.length < 2) return;
    var i = 0;
    setInterval(function(){
      slides[i].classList.remove('active');
      i = (i+1) % slides.length;
      slides[i].classList.add('active');
    }, 5000);
  });
})();
